import { __awaiter } from "tslib";
import { ProsemirrorHelper, EditorHelper } from '@getaccept/editor-lib-new';
import { nextTick, watch, computed, defineComponent, ref } from 'vue';
import ProsemirrorViewerFormOption from './ProsemirrorViewerFormOption.vue';
export default defineComponent({
    name: 'InputDropdown',
    components: {
        ProsemirrorViewerFormOption,
    },
    props: {
        checked: { type: Boolean },
        editable: { type: Boolean },
        fields: { type: Array, default: () => [] },
        input: {
            type: Object,
            default: () => ({}),
        },
        fieldFocused: { type: Boolean },
        mergeValues: { type: Object, default: () => ({}) },
        recipientInput: { type: Array, default: () => [] },
        isPdfViewer: { type: Boolean },
        tooltip: { type: Object, default: () => ({}) },
        hasUpdateError: { type: Boolean },
        isUpdating: { type: Boolean },
    },
    emits: ['update-selected'],
    setup(props) {
        const isScrolling = ref(false);
        const selectedIndex = ref(0);
        const isDisabled = computed(() => !props.editable && !props.isPdfViewer);
        const preventOpenIfDisabled = (event) => {
            if (!props.editable) {
                event.stopPropagation();
            }
        };
        const mergeTagValue = (mergeTag) => ProsemirrorHelper.getMergeValueFromMergeTag(ProsemirrorHelper.getTagIdFromMergeTag(mergeTag), props.fields, props.mergeValues);
        const showDropdownOption = (option) => {
            const optionList = option.trim().split(' ');
            const filteredOption = optionList
                .map(item => (EditorHelper.hasMergeTags(item) ? mergeTagValue(item) : item))
                .filter(item => item !== '');
            return !!filteredOption.length;
        };
        const handleKeyEnter = () => {
            selectedIndex.value = props.input.inputSettings.options.indexOf(props.input.value);
        };
        const handleKeyUp = () => {
            if (selectedIndex.value === 0) {
                return;
            }
            selectedIndex.value--;
        };
        const handleKeyDown = () => {
            if (selectedIndex.value === props.input.inputSettings.options.length - 1) {
                return;
            }
            selectedIndex.value++;
        };
        watch(() => props.fieldFocused, (fieldFocused) => {
            if (fieldFocused) {
                const input = document.getElementById(props.input.id);
                input.focus({
                    preventScroll: true,
                });
            }
        });
        watch(selectedIndex, () => __awaiter(this, void 0, void 0, function* () {
            var _a;
            yield nextTick();
            (_a = document.querySelector('.dropdown-content .select-option-item.selected')) === null || _a === void 0 ? void 0 : _a.scrollIntoView({
                block: 'nearest',
                behavior: 'smooth',
            });
        }));
        return {
            isScrolling,
            selectedIndex,
            isDisabled,
            preventOpenIfDisabled,
            handleKeyEnter,
            handleKeyUp,
            handleKeyDown,
            getDropdownValueContent: EditorHelper.getDropdownValueContent,
            getInputContent: ProsemirrorHelper.getInputContent,
            showDropdownOption,
        };
    },
});
